// extracted by mini-css-extract-plugin
module.exports = {"ProductDetail":"ProductDetail_ProductDetail__ZKxUH"};